import React from 'react'
import PropTypes from 'prop-types'
import icon from '../img/Checkbox.svg'

class Checkbox extends React.Component {
  state = {
    value: this.props.value
  }

  static propTypes = {
    /**
     * Value of the input. Sets whether the component is checked or not.
     */
    value: PropTypes.bool,
    /**
     * Node displayed with the checkbox (can be a string).
     */
    label: PropTypes.node,
    /**
     * A callback function to be called when the checkbox changes.
     */
    changeCallback: PropTypes.func,
  }

  handleChange = event => {
    event.persist()

    this.setState({ value: event.target.checked }, () => {
      if (typeof this.props.changeCallback === 'function') {
        this.props.changeCallback(event)
      }
    })
  }

  componentWillReceiveProps = nextProps => {
    let newState = {}

    if (nextProps.value !== this.props.value) {
      newState.value = nextProps.value
    }

    this.setState(newState)
  }

  getLabel = () => {
    const title = typeof this.props.label === 'string' ? this.props.label : ''

    if (this.props.label) {
      return <label title={title}>{this.props.label}</label>
    }

    return null
  }

  render = () => {
    const {
      changeCallback,
      value,
      name,
      label,
    } = this.props
    const title = typeof label === 'string' ? label : ''

    return (
      <div className='checkbox-component'>
        <input type='checkbox' checked={this.state.value} onChange={this.handleChange} value={value} name={name} label={label} title={title}></input>
        <div>
          <div className='checkbox-input'>
            <img src={icon} />
          </div>
          {this.getLabel()}
        </div>
      </div>
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/js/Checkbox.js